export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";